"use client";

import { useEffect } from "react";
import BookDetailPageLayout from "@components/Layout/BookDetailPageLayout";
import LayoutWithoutAds from "@components/Layout/LayoutWithoutAds";
import { useAppContext } from "@components/Provider";
import TagManager from "react-gtm-module";

const BookDetailLayout = ({ children, hideHeader }) => {
  const { data } = useAppContext();

  useEffect(() => {
    if (!data?.SiteSettings?.gtm_container_id) return;

    // Delay GTM initialization until layout is stable
    const id = data.SiteSettings.gtm_container_id;

    requestAnimationFrame(() => {
      TagManager.initialize({ gtmId: id });
    });
  }, [data?.SiteSettings?.gtm_container_id]);

  const showAdsOnSite = data?.SiteSettings?.ad_settings?.show_ads ?? true;

  //If Site settings data says do not show ad in page than use LayoutWithoutAds as layout
  //Else use BookDetailPageLayout as layout
  if (!showAdsOnSite) {
    return <LayoutWithoutAds hideHeader={hideHeader}>{children}</LayoutWithoutAds>;
  }

  return <BookDetailPageLayout>{children}</BookDetailPageLayout>;
};

export default BookDetailLayout;
